export default __webpack_public_path__ + "static/stepOneNecklaceImg-ca6fbde171f1aa8e9a9e751be4d0c1ce.jpg";